/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Why a load() call did not reach playback. Stamped on ILoadRequest.reason.
 * Undefined on the winning call that reaches playback.
 */
export enum LoadRequestReason {
	/** Rejected by the Throttler — call arrived within the throttle window. */
	THROTTLED = 'throttled',
	/** Overwritten in the pending slot by a newer load() call. */
	SUPERSEDED = 'superseded',
	/** allowedToLoadVideo() returned false — load gate blocked execution. */
	DISALLOWED = 'disallowed',
	/** stopPlayer() rejected before the load chain could continue. */
	STOP_PLAYER_FAILED = 'stop-player-failed',
	/** ON_CREATE_PLAYER_FAILURE fired — player creation failed after execution began. */
	CREATION_FAILED = 'creation-failed',
	/** TAG.invalidJwtLoadGuard blocked execution — no usable JWT for a Stitcher load() call. */
	MISSING_JWT = 'missing-jwt',
}